import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import NormalizeStrategies from '~shared/components/score-board/normalizers';
import classNames from 'classnames';
import { Link } from '~spa/Components/Link/Link';
import { seoUrlEvent, seoUrlInplayEvent } from '~spa/Utils/SeoUrls';
import { getTeamLogoUrl } from '~shared/utils/sportsbook';
import '~shared/components/react/Scoreboard/styles/scoreboard-wrapper.scss';
import './styles.scss';

const EventDescription = (props) => {
    const {
        gtm = '',
        hasBoostedOddsSelections = false,
        event: {
            id: eventId,
            sport_slug,
            category_slug,
            isUsFormat = false,
            event_url: eventUrl,
            inplay: isInplay = false,
            usesThreeMarketView = false,
            competitors: _competitors = [],
            tournament_logos: tournamentLogos = {},
            is_streaming_available: isStreamingAvailable = false,
        },
    } = props;

    // This is to account for 'competitors' sometimes being an object and sometimes
    // being an array depending on the endpoint.
    const competitors = Object.values(_competitors);
    const normalize = NormalizeStrategies[sport_slug];

    const {
        status = '',
        columns = [],
    } = (isInplay && normalize?.(props.event)) || {};

    const url = isInplay ? seoUrlInplayEvent(eventUrl, eventId) : seoUrlEvent(eventUrl, eventId);

    const scores = columns.reduce((acc, column) => {
        const [home, away] = column;

        return {
            home: [...acc.home, home],
            away: [...acc.away, away],
        };
    }, {away:[], home:[]});

    const shouldShowTeamLogo = Boolean(tournamentLogos?.showTeamLogo);

    const gridTemplate = classNames(
        {'min-content': shouldShowTeamLogo},
        '1fr',
        {[`repeat(${scores.home.length}, min-content)`]: scores.home.length},
    );

    const gridStyle = {
        gridTemplateColumns: gridTemplate,
    };

    const toGridRow = (competitor, index) => {
        const isHome = index === 0;
        const competitorScores = isHome ? scores.home : scores.away;
        const key = isHome ? 'home' : 'away';

        return <Fragment key={index}>
            {shouldShowTeamLogo
                ? <img
                    src={getTeamLogoUrl(sport_slug, category_slug, competitor.slug)}
                    className="featured-matches-widget__competitor-logo"
                />
                :null
            }
            <span key={key} className="featured-matches-widget__event-text featured-matches-widget__event-competitor">
            {// it's not a classname but works too well not to use.
                classNames(competitor.name, { '@': isUsFormat && !isHome })
            }
            </span>
            {
                competitorScores.map((score, index, competitorScores) => {
                    const isLast = index+1 === competitorScores.length;
                    const { bemModifiers = [], value = '' } = score || {};
                    const modifiers = bemModifiers.map(modifier => `bb-score-board__score-field--${modifier}`);
                    const classes = classNames( 'bb-score-board__score-field', modifiers, {
                        'bb-score-board__score-field--last-score': isLast,
                    });

                    return <span key={`${key}_${index}`} className={classes}>{value}</span>;
                })
            }
        </Fragment>;
    };

    const gridRows = competitors.map(toGridRow);

    const mainClassNames = classNames('event-description', {
        'event-description--inplay': isInplay,
        'event-description--three-market': usesThreeMarketView,
    });

    return <Link className={mainClassNames} to={url} gtmAttribute={gtm}>
        <div className='event-description__grid' style={gridStyle}>
            {isUsFormat
                ? [...gridRows].reverse()
                : gridRows
            }
        </div>
        <div className='event-description__footer'>
            <span className='event-description__status'>
                {status}
            </span>
            <span className='event-description__icons'>
                {hasBoostedOddsSelections && <span className='event-description__icons-boosted-odds'/>}
                {isStreamingAvailable && <span className='event-description__icons-streaming'/>}
            </span>
        </div>
    </Link>;
};

EventDescription.propTypes = {
    event: PropTypes.object.isRequired,
    isStreamingAvailable: PropTypes.bool,
    hasBoostedOddsSelections: PropTypes.bool,
    gtm: PropTypes.string,
};

export default EventDescription;
